import { APP_STYLE_BACKSLASH_REPLACEMENT } from '../constants';

const STYLE_ELEMENT_ID = 'appdef-custom-styles';

// BE bar styles come as `<class> .row-color { ... }`. No `.row-color` element
// exists, so repaint the bar onto the first cell's pseudo-element (and the
// expansion row, so it stays continuous). See Grid.css.
const ROW_COLOR_RULE = /([^{}]+?)\s+\.row-color\s*\{([^}]*)\}/g;

const expandRowColorRules = (css: string): string =>
  css.replace(ROW_COLOR_RULE, (_, selector: string, body: string) => {
    const sel = selector.trim();
    return (
      `${sel} > td:first-child::before,\n` +
      `${sel} + tr.p-datatable-row-expansion > td:first-child::before {${body}}`
    );
  });

const transformCss = (css: string): string =>
  expandRowColorRules(css).replace(/\\\\/g, APP_STYLE_BACKSLASH_REPLACEMENT);

export const injectAppStyles = (css: string): void => {
  let el = document.getElementById(STYLE_ELEMENT_ID) as HTMLStyleElement | null;
  if (!el) {
    el = document.createElement('style');
    el.id = STYLE_ELEMENT_ID;
    document.head.appendChild(el);
  }
  el.textContent = transformCss(css);
};
